import { useIoContext } from '~/contexts';
export const useInvoiceDateContext = (param)=>{
    let { invoiceDateInfo, earliestBillableDate, effectiveDate } = param;
    const { getNow } = useIoContext();
    return {
        invoiceDateInfo,
        earliestBillableDate,
        effectiveDate,
        now: getNow()
    };
};
